//NEW: UI_REVAMP
import { Grid } from '@chakra-ui/react';
import { DIGITS } from '../../../constant/bet1';
import Bet1Button from './Bet1Button';

const BetOne3DKeypad = ({ selection = [[], [], []], onDigitClick, isDisabled }) => {
	return (
		<Grid
			className='numbers-container'
			templateColumns='repeat(3, 1fr)'
			gap={4}
			flex='1'
			minH='0'
			h='full'
			bg={{ base: 'rgba(255, 255, 255, 0.30)', lg: 'none' }}
			py={{ base: 2, lg: 0 }}
			px={{ base: 4, lg: 0 }}
			borderRadius={{ base: 8, lg: 0 }}
			boxShadow={{ base: '0 0 4px 0 #8674FE', lg: 'none' }}
		>
			{selection.map((colSelection, colIdx) => (
				<Grid
					key={colIdx}
					templateRows='repeat(10, 1fr)'
					gap={2}
					h='full'
					justifyItems='center'
					alignItems='center'
				>
					{DIGITS.map((digit) => {
						const isSelected = colSelection.includes(digit.toString());

						return (
							<Bet1Button
								key={digit}
								digit={digit}
								isSelected={isSelected}
								onDigitClick={onDigitClick}
								colIdx={colIdx}
								actualColIdx={colIdx}
								isDisabled={isDisabled}
							/>
						);
					})}
				</Grid>
			))}
		</Grid>
	);
};

export default BetOne3DKeypad;
